/** @jsx jsx */
import { jsx } from '@emotion/react'

import { AddComment, Comment } from '..'
import { Modal, ModalHeader, ModalBody } from '../../../../shared/modal'
import { ModalSize } from '../../../../shared/modal/Modal/Modal'
import { BoardGroupFragment } from '../../../../../generated/graphql'

type AddCommentModalProps = {
  /** Current Plan Group */
  group: BoardGroupFragment
  /** Indicates if the modal is open */
  isOpen: boolean
  /** Indicates if this plan is a template */
  isTemplate: boolean
  /** Event callback when user triggers a close event (eg. button click or ESC key) */
  onCancel: () => void
  /** Event callback when the save (add) comment button is clicked */
  onSave?: () => void
  /** Indicates if this plan/template is read-only */
  readOnly?: boolean | undefined
  /** Show the add comment field when clicking Add Comment from the group menu */
  showAddComment: boolean
  /** Show the comments when clicking on the comment count button */
  showComments: boolean
  /** Show the new comment indicator for this term/group */
  showNewCommentIndicator: boolean
}

const defaultProps: Pick<AddCommentModalProps, 'onSave' | 'readOnly'> = {
  onSave: undefined,
  readOnly: false
}

const AddCommentModal = ({
  group,
  isOpen,
  isTemplate,
  onCancel,
  onSave,
  readOnly,
  showAddComment,
  showComments,
  showNewCommentIndicator
}: AddCommentModalProps) => {
  const renderComments = () => {
    if (group && group.comments && group.comments.length > 0) {
      return group.comments.map((cmt: any) => (
        <Comment
          key={cmt.id}
          comment={cmt}
          isTemplate={isTemplate}
          readOnly={readOnly}
          showNewCommentIndicator={showNewCommentIndicator}
        />
      ))
    }
    return null
  }

  return (
    <Modal allowMobilePage isOpen={isOpen} size={ModalSize.LG}>
      <ModalHeader allowMobile onClose={onCancel} title={`Comments on ${group.title}`} />
      <ModalBody allowMobile>
        {!readOnly && (
          <AddComment
            group={group}
            isTemplate={isTemplate}
            onCancel={onCancel}
            onSaveComment={onSave}
            showAddComment={showAddComment}
            showComments={showComments}
          />
        )}
        <div>{renderComments()}</div>
      </ModalBody>
    </Modal>
  )
}

AddCommentModal.defaultProps = defaultProps

export default AddCommentModal
